import { ConcreteEncodable } from "./ConcreteEncodable";

import { OrderAcceptanceRequestImplEncoder } from "../../encoder/OrderAcceptanceRequestImplEncoder";

import * as CubiqTS from "../../index";
import { OrderAcceptanceRequest } from "../OrderAcceptanceRequest";

export class OrderAcceptanceRequestImpl
  extends ConcreteEncodable
  implements OrderAcceptanceRequest
{
  public static enType: string = "com.bcdfx.model.event.OrderAcceptanceRequestImpl";

  /*FID=1*/
  public acceptanceAction: CubiqTS.AcceptanceAction;
  /*FID=2*/
  public acceptanceType: CubiqTS.AcceptanceType;
  /*FID=3*/
  public orderIds: Array<string> | null = null;
  /*FID=4*/
  public targetGroupID: CubiqTS.Long | null = null;
  /*FID=5*/
  public comment: string;
  /*FID=6*/
  public callOrderRateSide: CubiqTS.RateSideType;
  /*FID=7*/
  public orderType: CubiqTS.OrderType;
  /*FID=8*/
  public benchmarkOrderType: CubiqTS.BenchmarkOrderType;
  /*FID=100*/
  public messageId: string;
  /*FID=200*/
  public brokerId: string;
  /*FID=300*/
  public secureToken: CubiqTS.SecureToken | null = null;
  /*FID=999*/
  public proxySessionId: string;
  /*FID=10000*/
  public svrRxTime: CubiqTS.Long | null = null;
  /*FID=10001*/
  public svrTxTime: CubiqTS.Long | null = null;
  /*FID=10002*/
  public cliTxTime: CubiqTS.Long | null = null;
  /*FID=10003*/
  public cliRxTime: CubiqTS.Long | null = null;
  public sessionOnly: string;

  constructor() {
    super();
    this.encoder = OrderAcceptanceRequestImplEncoder.Instance;
    this.setEncodableType(OrderAcceptanceRequestImpl.enType);
    this.messageId = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
      let r = (Math.random() * 16) | 0,
        v = c == "x" ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  }

  public toString(): string {
    return (
      "OrderAcceptanceRequestImpl[" +
      "acceptanceAction=" +
      this.acceptanceAction +
      "acceptanceType=" +
      this.acceptanceType +
      "orderIds=" +
      this.orderIds +
      "targetGroupID=" +
      this.targetGroupID +
      "comment=" +
      this.comment +
      "callOrderRateSide=" +
      this.callOrderRateSide +
      "orderType=" +
      this.orderType +
      "benchmarkOrderType=" +
      this.benchmarkOrderType +
      "messageId=" +
      this.messageId +
      "brokerId=" +
      this.brokerId +
      "secureToken=" +
      this.secureToken +
      "proxySessionId=" +
      this.proxySessionId +
      "svrRxTime=" +
      this.svrRxTime +
      "svrTxTime=" +
      this.svrTxTime +
      "cliTxTime=" +
      this.cliTxTime +
      "cliRxTime=" +
      this.cliRxTime +
      "]"
    );
  }

  public validateInbound(): void {}

  public validateOutbound(): void {}
}
